import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import styled from "styled-components/macro";

import API from "Payments/PaymentPage/API";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { motion, useAnimation } from "framer-motion";

import FnrIcon from "UI/FnrIcon";

ResendCodeButton.propTypes = {
  onResendComplete: PropTypes.func.isRequired,
  setErrorCode: PropTypes.func.isRequired,
  accentColor: PropTypes.string,
};

export default function ResendCodeButton({
  onResendComplete,
  setErrorCode,
  accentColor,
}) {
  const { state, dispatch } = usePaymentPage();
  const { loginValueType, loginValue } = state.authCodeData;
  const [shouldSubmit, setShouldSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [isRotating, setIsRotating] = useState(false);

  useEffect(
    function submitToAPI() {
      if (!shouldSubmit) return;

      const payload = {
        subscribedVia: "payment",
      };
      if (loginValueType === "phone") {
        payload.phone = loginValue;
      } else {
        payload.email = loginValue;
      }

      const sendAuthCodeCall = API.sendAuthCode(payload);

      setErrorCode(null);
      setIsLoading(true);
      setIsRotating(true);
      sendAuthCodeCall
        .post()
        .then(() => {
          setIsLoading(false);
          setShouldSubmit(false);
          onResendComplete();
        })
        .catch(() => {
          setErrorCode("resendError");
          setIsLoading(false);
          setShouldSubmit(false);
        });

      return () => {
        if (sendAuthCodeCall.cancel) sendAuthCodeCall.cancel();
      };
    },
    [
      loginValue,
      loginValueType,
      dispatch,
      shouldSubmit,
      setShouldSubmit,
      onResendComplete,
      setErrorCode,
    ]
  );

  return (
    <Wrapper>
      <Button
        onClick={() => setShouldSubmit(true)}
        whileHover={{ color: accentColor }}
        whileTap={{ scale: 0.95 }}
      >
        <Text>Resend</Text>

        <Icon
          key={isLoading || isRotating ? "rotating" : "motionless"}
          animate={
            (isLoading || isRotating) && {
              rotate: 360,
              transition: {
                duration: 1.2,
                repeat: 0,
                onComplete: () => setIsRotating(false),
              },
            }
          }
        >
          <FnrIcon fas fa-redo />
        </Icon>
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  z-index: 101;
  display: flex;
  justify-content: center;
`;
const Button = styled(motion.button)`
  appearance: none;
  border: 0;
  margin: 0;
  padding: 0;
  background: none;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #828c8d;
  font-size: 13px;
`;
const Text = styled.div`
  margin-right: 4px;
`;
const Icon = styled(motion.div)`
  font-size: 10px;
`;
